<div class="row">
  <div class="col-12">
    <div class="card">
      <form [formGroup]="formGroup">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 col-md-9 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'warningWord.list.searchPlaceholder' | translate"
                formControlName="search"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div class="col-xs-12 col-md-3 btn-group trend-button">
              <button class="btn btn-success fw-bold" (click)="add()">
                + {{ 'warningWord.list.add' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="card">
  @if (pager.total == 0) {
    <empty-records-component
      [message]="'warningWord.list.emptyMessage' | translate"
      [subMessage]="'warningWord.list.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
      [labelButton]="'warningWord.list.labelButtonAdd' | translate"
      (emitEvent)="add()"
    />
  }

  @if (pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'warningWord.list.columnTitle' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'warningWord.list.columnCreatedAt' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'warningWord.list.columnWarningWords' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
            <tr>
              <td>
                <span
                  class="badge font-14"
                  [ngStyle]="{ 'background-color': item.bgColor, color: (item.bgColor | readableText) }"
                >
                  {{ item.title }}
                </span>
              </td>
              <td>
                <span>{{
                  item.createdAt
                    | timezoneDate
                      : "DD/MM/YYYY"
                      : getTimezoneCompanyCurrentUser()
                }}</span
                ><br />
                <span>{{
                  item.createdAt
                    | timezoneDate: "HH:mm" : getTimezoneCompanyCurrentUser()
                }}</span>
              </td>
              <td>
                @for (keyword of item?.keyword; track $index) {
                  <span class="badge font-14 bg-info gap-2 me-1">{{
                    keyword
                  }}</span>
                }
              </td>

              <td>
                <div class="d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="edit(item)">
                      {{ 'warningWord.list.edit' | translate }}
                    </button>
                    <button mat-menu-item tabindex="0" (click)="delete(item)">
                      {{ 'warningWord.list.remove' | translate }}
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  }
</div>
